import moment from 'moment';
import React from 'react'
import ReactImageFallback from 'react-image-fallback';

// images
import defaultUser from "../../assets/images/default_profile_pic.jpg";


export default function Sender(props) {
    return (
        <>
            {/* ************** Sender UI  */}
            <li className="userChat_send_msg ms-auto w-100">
                <div className="w-100">
                    <h6 className="lh-sm small mb-2">
                        {props?.chat?.sender_details?.first_name != null && props?.chat?.sender_details?.last_name != null ? props?.chat?.sender_details?.first_name + " " + props?.chat?.sender_details?.last_name : props?.chat?.sender_details?.name}
                        <br /><small className='text-muted fw-normal'>{moment(props?.chat.created_at).startOf('hour').fromNow()}</small>
                    </h6>
                    <p className="message_body shadow-sm ms-auto">
                        {props?.chat?.text}
                    </p>
                </div>
                
                <ReactImageFallback
                    src={`${process.env.REACT_APP_BASE_URL}/public/storage/${props?.senderDetail?.profile_image}`}
                    initialImage={defaultUser}
                    fallbackImage={defaultUser}
                    alt="avatar"
                    className="rounded-circle d-flex align-self-start shadow-1-strong ms-3"
                    width="40"
                />
            </li>
        </>
    )
}
